import {Link, Typography, makeStyles} from '@material-ui/core';
import {safeRenderValue} from 'Quoting/utils/utilities';
import React from 'react';

const useOpportunityDetailsHeaderStyles = makeStyles(() => ({
  opportunity: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: '50%',

    '& div': {
      display: 'flex',
      flexDirection: 'column',
    },

    '& > div:first-child': {
      '& > :first-child': {
        fontSize: '0.875rem',
        fontWeight: 500,
      },

      '& > :nth-child(2)': {
        fontSize: '1.125rem',
        lineHeight: '1.5rem',
        fontWeight: 600,
      },
    },
  },
  policyNumber: {
    paddingTop: '0.15rem',
    fontWeight: 500,
  },
}));

export const OpportunityTitle = ({
  opportunityId,
  policyNumber,
  customerName,
}: {
  opportunityId: string;
  policyNumber?: string;
  customerName?: string;
}) => {
  const classes = useOpportunityDetailsHeaderStyles();
  return (
    <div className={classes.opportunity}>
      <div>
        <Typography>Opportunity Case</Typography>
        <Typography>
          <Link href={`/#/quoting/opportunity/${opportunityId}`}>#{opportunityId}</Link>
        </Typography>
      </div>
      <div>
        {customerName && <Typography>Customer Name: {safeRenderValue(customerName)}</Typography>}
        {policyNumber && <Typography className={classes.policyNumber}>Master Policy #: {policyNumber}</Typography>}
      </div>
    </div>
  );
};
